<script setup>
import { to } from "await-to-js";
import { ref, onMounted } from "vue";
//import { get } from "lodash";
import { interceptor } from "@dutypay/utilities";
import { useEnvStore } from "@dutypay/store-modules";
import { ElNotification } from "element-plus";
const loading = ref(false);
const envStore = useEnvStore();

async function generateTranslationFiles() {
  loading.value = true;
  let err, res;
  [err, res] = await to(
    interceptor.post(
      `${envStore.apiUrls.dutypay}/api/v0/translations/generate`,
      {}
    )
  );
  if (err) {
    loading.value = false;
    ElNotification({
      title: err.message,
      type: "error",
      message: err.response.data.message,
    });
    return;
  }
  ElNotification({
    title: "Success!",
    type: "success",
    message: "Translation Files generated successfully.",
  });
  loading.value = false;
}

onMounted(async () => {});
</script>

<script>
export default {
  name: "TranslationsPage",
};
</script>

<template>
  <div>
    <el-row>
      <el-column>
        <h1>Generate Translation Files</h1>
        <el-alert
          type="warning"
          title="Can take up to 2 minutes."
          effect="dark"
          :closable="false"
        ></el-alert>
        <p>
          <el-button
            type="primary"
            :loading="loading"
            @click="generateTranslationFiles"
            >Generate Translation Files</el-button
          >
        </p>
      </el-column>
    </el-row>
  </div>
</template>

<style scoped lang="scss">
.searchform {
  display: inline-flex !important;
}
</style>

<i18n>
  {
  "en-US": {
  }
  }
</i18n>
